import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, PopoverController, LoadingController, AlertController, ModalController, ToastController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Chart } from 'chart.js';
import { DatabaseProvider } from '../../providers/database/database';
import { UtilityProvider } from '../../providers/utility/utility';
import { PatientDetailsPage } from '../patient-details/patient-details';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { LoginPage } from '../login/login';
import { FormGroup, FormBuilder } from '@angular/forms';
import { PatientProvider } from '../../providers/patient/patient';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {
  private ngUnsubscribe: Subject<any> = new Subject();

  displayedColumns = ['checkbox', 'type', 'priority', 'due_date', 'assigneduser', 'last_name', 'program_patient_id', 'notes', 'actions'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  @ViewChild('ytdStatusCanvas') ytdStatusCanvas;
  ytdStatusPie: any;

  @ViewChild('ytdCCCanvas') ytdCCCanvas;
  ytdCCPie: any;

  @ViewChild('barCanvas') barCanvas;
  barChart: any;

  message: string;
  toastBackground: string = null;
  program_name: string = null;
  program_id: string = null;
  program_logo: string = null;

  doctors: any;

  indication: string;

  compassionate = 0;
  commercial = 0;
  status: any;

  searcForm: FormGroup;
  isLoading: boolean;
  errorMsg: string;

  t = [
    { label: 'test 1', value: 5 },
    { label: 'test 2', value: 4 },
    { label: 'test 3', value: 2 },
    { label: 'test 4', value: 1 },
  ];

  patients: any[] = [];
  tasks: any[] = [];
  exportjson: any[] = [];
  tasks_completed: any[] = [];
  hcc_count: number;
  dtc_count: number;
  rcc_count: number;

  kpi: any;
  patients_enrol1: any[] = [];
  patients_enrol2: any[] = [];
  patients_enrol3: any[] = [];
  patients_norisk: any[] = [];

  userid: string;
  user_fullname: string;
  
  alert_count = 0;
  buttondisabled = false;
  patientid: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public popoverCtrl: PopoverController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    private dbPatient: PatientProvider,
    private utility: UtilityProvider,
    private fb: FormBuilder
  ) {
    this.indication = "wAMD";
    this.auth.getCurrentUser().then(user => {
      this.userid = user.id;
      this.user_fullname = user.first_name + ' ' + user.last_name;
      this.program_name = user.program_name;
      this.program_id = user.program_id;


      if (user.roles.program_admin) {

        this.database
          .getPatientsByProgram(this.program_id)
          .snapshotChanges()
          .map(actions => {
            return actions.map(a => {
              const data = a.payload.doc.data() as any;
              data.id = a.payload.doc.id;
              return data;
            });
          })
          .takeUntil(this.ngUnsubscribe)
          .subscribe((patients) => {
            // console.log(patients);
            this.patients = patients;


            this.hcc_count = this.patients.filter((obj) => obj.indication === 'wAMD').length;
            this.dtc_count = this.patients.filter((obj) => obj.indication === 'CRVO').length;
            this.rcc_count = this.patients.filter((obj) => obj.indication === 'BRVO').length;

            this.commercial = this.patients.filter((obj) => (obj.type === 'Commercial' && obj.indication === this.indication)).length;
            this.compassionate = this.patients.filter((obj) => (obj.type === 'Compassionate' && obj.indication === this.indication)).length;

            const t = this.patients.filter((obj) => obj.indication === this.indication).map(obj => obj.status).reduce((r, c) => (r[c] = (r[c] || 0) + 1, r), {});
            this.status = Object.keys(t).map((k) => ({ status: k, value: t[k] }));
            // console.log('status: ', this.status);
          });
        this.getStatistics();
      } else {
        this.database
          .getPatientsByStatusRisk(this.program_id, 'Program Start')
          .snapshotChanges()
          .map(actions => {
            return actions.map(a => {
              const data = a.payload.doc.data() as any;
              data.id = a.payload.doc.id;
              return data;
            });
          })
          .takeUntil(this.ngUnsubscribe)
          .subscribe((patients) => {
            // console.log('Patients: ', patients);
            this.patients = patients;
            const today = moment().format('MM/DD/YYYY');
            // console.log(today);
          });

        this.database
          .getPatientsByProgram(this.program_id)
          .snapshotChanges()
          .map(actions => {
            return actions.map(a => {
              const data = a.payload.doc.data() as any;
              data.id = a.payload.doc.id;
              return data;
            });
          })
          .takeUntil(this.ngUnsubscribe)
          .subscribe((patients) => {
            // console.log('Patients: ', patients);
            this.patients_enrol1 = patients.filter((obj) => obj.status === 'Enrolment Call #1');
            this.patients_enrol2 = patients.filter((obj) => obj.status === 'Enrolment Call #2');
            this.patients_enrol3 = patients.filter((obj) => obj.status === 'Enrolment Call #3');
            // console.log(this.patients_enrol1, this.patients_enrol2, this.patients_enrol3);
          });

        this.database
          .getTasksByProgram(this.program_id)
          .snapshotChanges()
          .map(actions => {
            return actions.map(a => {
              const data = a.payload.doc.data() as any;
              data.id = a.payload.doc.id;
              return data;
            });
          })
          .takeUntil(this.ngUnsubscribe)
          .subscribe(tasks => {
            // console.log('Tasks: ', tasks);
            this.tasks = tasks.sort(task => !task.completed ? -1 : 1);
            //this.tasks_completed = tasks.filter(task => task.assigneduser_id === this.userid && task.completed);

            this.dataSource = new MatTableDataSource(this.tasks);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            // console.log('My Tasks: ', this.tasks);
            // this.note_history = this.patient['note_history'].filter(item => item['note_type'] !== 'Task' && item['note_type'] !== 'Status')
          });

        


        this.database
          .getPatientsByProgramStartNoRisk(this.program_id, 'Program Start')
          .snapshotChanges()
          .map(actions => {
            return actions.map(a => {
              const data = a.payload.doc.data() as any;
              data.id = a.payload.doc.id;
              return data;
            });
          })
          .takeUntil(this.ngUnsubscribe)
          .subscribe((patients) => {
            // console.log('Patients: ', patients);
            this.patients_norisk = patients;
          });
      }
    })
  }

  ngOnDestroy() {
    console.log('Leaving home view and destroying subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }


  changeIndication(ev) {
    this.indication = ev.value;
    console.log(this.indication);
    this.hcc_count = this.patients.filter((obj) => obj.indication === 'wAMD').length;
    this.dtc_count = this.patients.filter((obj) => obj.indication === 'CRVO').length;
    this.rcc_count = this.patients.filter((obj) => obj.indication === 'BRVO').length;

    this.commercial = this.patients.filter((obj) => (obj.type === 'Commercial' && obj.indication === this.indication)).length;
    this.compassionate = this.patients.filter((obj) => (obj.type === 'Bridging' && obj.indication === this.indication)).length;

    const t = this.patients.filter((obj) => obj.indication === this.indication).map(obj => obj.status).reduce((r, c) => (r[c] = (r[c] || 0) + 1, r), {});
    this.status = Object.keys(t).map((k) => ({ status: k, value: t[k] }));
    console.log('status: ', this.status);
    this.getStatistics();
  }

  getStatistics() {
    const loading = this.loadingCtrl.create({});
    this.database.getIndicationByProgram(this.program_id, this.indication).valueChanges().subscribe((stats) => {
      if (stats) {
        // this.compassionate = stats['Compassionate'];
        // this.commercial = stats['Commercial'];
        // this.status = stats['Status'];
        this.generateCCChart();
        this.generateStatusChart();
        this.generateYTDChart();
      }
      if (this.hcc_count > 0) {
        this.generateCCChart();
        this.generateStatusChart();
        this.generateYTDChart();
      }

    });
  }

  generateCCChart() {
    const areachartWidgetData = {
      labels: ['Commercial (' + this.commercial.toString() + ')', 'Bridging (' + this.compassionate.toString() + ')'],
      datasets: [{
        data: [this.commercial, this.compassionate],
        backgroundColor: [
          '#2d4b80',
          '#ed8039'
        ]
      }],
    };

    this.ytdCCPie = new Chart(this.ytdCCCanvas.nativeElement, {
      type: 'pie',
      data: areachartWidgetData,
      options: {
        responsive: true,
        legend: {
          display: true
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
      }
    });
  }

  generateStatusChart() {
    const areachartWidgetData = {
      labels: Object.keys(this.status).map(a => this.status[a]['status'] + ' (' + this.status[a]['value'] + ')'),
      datasets: [{
        data: Object.keys(this.status).map(a => this.status[a]['value']),
        backgroundColor: [
          '#2d4b80',
          '#ed8039',
          '#cccccc',
          '#ffc21c',
          '#70a6da',
          '#7ab356',
          '#ffcc66',
          'green',
          'purple'
        ]
      }]
    };

    this.ytdStatusPie = new Chart(this.ytdStatusCanvas.nativeElement, {
      type: 'pie',
      data: areachartWidgetData,
      options: {
        responsive: true,
        legend: {
          display: true
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
      }
    });

  }

  generateYTDChart() {
    const labels = ['wAMD (' + this.hcc_count + ')', 'CRVO (' + this.dtc_count + ')', 'BRVO (' + this.rcc_count + ')'];
    const backgroundColor = ['#009688', '#2196F3', '#9C27B0'];
    const data = [this.hcc_count, this.rcc_count, this.dtc_count].sort((a, b) => b - a);
    const total = data.reduce((pv, cv) => pv + cv, 0);

    const chartData = {
      labels: labels,
      datasets: [{
        backgroundColor: backgroundColor,
        borderColor: 'transparent',
        data: data,
      }]
    };

    this.barChart = new Chart(this.barCanvas.nativeElement, {
      // The type of chart we want to create
      type: 'pie',

      // The data for our dataset
      data: chartData,

      // Configuration options go here
      options: {
        responsive: true,
        legend: {
          display: true
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },

      }
    });
  }

  formatDate(val, format) {
    if (format) {
      return this.utility.formatDate(val, format);
    } else {
      return this.utility.formatDate(val, 'YYYY-MMM-DD');
    }
  }

  onSelect(ev, cell, row) {
    if(ev.checked)  {

    let alert = this.alertCtrl.create({
      title: 'Task Complete?',
      // inputs: [
      //   {
      //     name: 'note',
      //     placeholder: 'Completion note'
      //   }
      // ],
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
            ev.checked = false;
          }
        },
        {
          text: 'Yes',
          handler: data => {
            // console.log('note: ', data.note);
            console.log(ev, cell, row);
            let note = '';
            this.database.updateTask(this.program_id, this.userid, this.user_fullname, row.patient.id, row.id, note).then(() => {
              ev.checked = false;
            });
          }
        }
      ]
    });
    alert.present();
          
  }
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });
  
    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });
  
    toast.present();
  }

  exportTasks() {
    let task_download = [];
    this.tasks.filter(task => {
      const newtask = { 
        'Type': task.type,
        'Priority': task.priority,
        'Due Date': task.due_date ? task.due_date.toDate() : null,
        'Assign To': task.assigneduser, 
        'Assign By': task.createdBy.name,
        'Assigned Date': task.createdAt ? task.createdAt.toDate() : null,
        'Patient Name': task.patient ? task.patient.first_name + ' ' + task.patient.last_name : null,
        'Patient ID': task.patient.program_patient_id,
        'Notes': task.notes ? task.notes : null,
        'Completed': task.completed,
        'Completed Date': task.task_completed_date ? task.task_completed_date.toDate() : null
      }
      console.log('Task: ', newtask);
      task_download.push(newtask)
    });

    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(task_download);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Tasks'); // add the worksheet to the book
    XLSX.writeFile(workBook, moment().format('YYYY-MMM-DD-HHssA') + '-tasks.xlsx'); // initiate a file download in browser
  }

  viewPatient(task)  {
    this.navCtrl.push(PatientDetailsPage,{ 'patient_id': task.patient.id });
  }

  async signOut() {
    await this.auth.logout();
    await this.navCtrl.setRoot(LoginPage)
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts